/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IPaginatedList = Models.IPaginatedList;
    import INetworkNode = Models.INetworkNode;
    import IAlarmConfigs = Models.IDeviceAlarmConfig;
    import IEntity = Models.IEntity;
    import ISonNode = Models.ISonNode;
    import ISonLink = Models.ISonLink;
    import SonLink = Models.SonLink;
    import SonNode = Models.SonNode;
    import IConditionAlarmConfigMap = Models.IConditionAlarmConfigMap;

    interface IAlarmsSpecificsRouteParamsService extends ng.route.IRouteParamsService {
        deviceType: string;
        deviceId: string;
    }

    export class AdminAlarmsSpecificsController {
        public static $name: string = "adminAlarmsSpecificsController";
        public static $inject: string[] = ['$routeParams',
                                           'alarmsService',
                                           'networkNodeService',
                                           '$timeout',
                                           'sonAdapterService',
                                           ];

        public device: IEntity;
        public networkNodes: IPaginatedList<INetworkNode>;
        public severityColors: string[];
        public conditionKeys: string[];
        public conditionAlarmConfigMap: IConditionAlarmConfigMap = {};
        public conditionAlarmConfigCopyMap: IConditionAlarmConfigMap = {};
        public selectedCondition: string;
        // public alarmsConfigs: IAlarmConfigs;
        // public alarmsConfigsCopy: IAlarmConfigs;
        public errorsMap: string[];

        private searchText: string;
    
        private timeoutSearch: ng.IPromise<void>;
        private matchedNodes: INetworkNode[];

        constructor($routeParams: IAlarmsSpecificsRouteParamsService,
                    private alarmsService: Services.AlarmsService,
                    private networkNodeService: Services.NetworkNodeService,
                    private $timeout: ng.ITimeoutService,
                    private sonAdapterService: Services.SonAdapterService) {

            this.searchText = "";

            let deviceId: number = parseInt($routeParams.deviceId, 10);
            let deviceType: string = $routeParams.deviceType;
            // network node alarms view
            if (!isNaN(deviceId) && deviceId >= 0) {
                if (deviceType === 'networkNodes') {
                    let networkNodeId: number = deviceId;
                    this.networkNodeService
                        .getByIdPromise(networkNodeId)
                        .then((networkNode: Models.NetworkNode) => {
                            this.device = networkNode;
                            this.loadDeviceAlarmConfig();
                        });
                } else if (deviceType === SonLink.sonLinkClass) {
                    this.sonAdapterService.getSonPacketmap()
                        .then( (sonPacketMap: Models.ISonPacketmap) => {
                            sonPacketMap.links.forEach((sonLink: ISonLink) => {
                                if (sonLink.id === deviceId) {
                                    this.device = sonLink;
                                    this.device.href = SonLink.sonLinkPreHref + sonLink.id;
                                }
                            });
                            this.loadDeviceAlarmConfig();
                        });
                } else if (deviceType === SonNode.switchesClass) {
                    this.sonAdapterService.getSonPacketmap()
                        .then( (sonPacketMap: Models.ISonPacketmap) => {
                            sonPacketMap.switches.forEach((sonSwitch: ISonNode) => {
                                if (sonSwitch.id === deviceId) {
                                    this.device = sonSwitch;
                                    this.device.href = SonNode.switchesPreHref + sonSwitch.id;
                                }
                            });
                            this.loadDeviceAlarmConfig();
                        });
                }

            // general specific alarms view
            } else {
                networkNodeService
                    .getAllPaginatedNetworkNodesPromise(undefined, 1000)
                    .then((networkNodes: IPaginatedList<INetworkNode>) => {
                        this.networkNodes = networkNodes;
                        this.matchedNodes = networkNodes.elements;
                        for (let element of this.networkNodes.elements) {
                            element.id = Common.Utils.idFromHref(element.href).toString();
                        }
                    });
            }
        }

        public alarmsHaveBeenChanged(): boolean {
            let copy: IAlarmConfigs = this.getCurrentDeviceAlarmConfigCopy();
            let orig: IAlarmConfigs = this.getCurrentDeviceAlarmConfig();
            if (Common.Utils.exists(orig) && Common.Utils.exists(copy)) {
                this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
                return this.alarmsService.alarmsHaveBeenChanged(orig.alarmConfigs, copy.alarmConfigs);
            } else {
                return false;
            }
        }

        public changeMaskParam(alarmConfig: Models.IAlarmConfig): void {
            if (this.device !== undefined) {
                alarmConfig.masked = !alarmConfig.masked;
            }
        };

        public changeMaskLevel(alarmConfig: Models.IAlarmConfig, index: number): void {
            if (this.device !== undefined) {
                if ((alarmConfig.type as string) === 'relay' ||
                    (Common.Utils.exists(alarmConfig.levels[index].value) && alarmConfig.levels[index].value !== ''))
                    alarmConfig.levels[index].masked = !alarmConfig.levels[index].masked;
            }
        };

        public discardChanges(): void {
            this.conditionAlarmConfigCopyMap[this.selectedCondition].alarmConfigs =
                angular.copy(this.getCurrentDeviceAlarmConfig().alarmConfigs);
        }

        public saveChanges(): void {
            let copy: IAlarmConfigs = this.getCurrentDeviceAlarmConfigCopy();
            this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
            if (!this.errorsMap) {
                this.alarmsService
                    .saveAlarmConfigs(copy)
                    .then((alarmConfig: IAlarmConfigs) => {
                        this.conditionAlarmConfigMap[alarmConfig.condition] = alarmConfig;
                        this.conditionAlarmConfigCopyMap[alarmConfig.condition] = Common.Utils.clone(alarmConfig) as IDeviceAlarmConfig;
                    });
            }
        }

        // This implementation of searchbar only works for a defined number of devices.
        // Such number is defined when calling the method getAllPaginatedNetworkNodesPromise()
        public searchByText(): void {
            this.$timeout.cancel(this.timeoutSearch);
            this.applyFilter();
        }

        public searchAsType(): void {
            if (this.searchText !== undefined && this.searchText !== "") {
                this.$timeout.cancel(this.timeoutSearch);
                this.timeoutSearch = this.$timeout(() => {
                    this.applyFilter();
                }, 500);
            } else {
                this.matchedNodes = this.networkNodes.elements;
            }
        }

        public applyFilter(): void {
            this.matchedNodes = this.networkNodes.elements;
            this.matchedNodes = this.networkNodes.elements.filter((element: INetworkNode) => {
                return element.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
            });
        }

        public getSeverityColor(severity: number): string {
            return this.alarmsService.getSeverityColor(severity);
        }

        public escapeId(conditionKey: string, paramName: string): string {
            return conditionKey + "_" + paramName.replace(/\[/g, "_").replace(/\]/g, "_").replace(/\./g, "_");
        }

        private loadDeviceAlarmConfig(): void {
            this.alarmsService.getAlarmConfigsByHref(this.device.href)
                .then((alarmConfigs: IAlarmConfigs[]) => {
                    this.selectAlarmConfigForCondition(alarmConfigs);
                });
        }

        private selectAlarmConfigForCondition(alarmConfigs: IDeviceAlarmConfig[]): void {
            this.conditionAlarmConfigMap = {};
            this.conditionAlarmConfigCopyMap = {};
            alarmConfigs.forEach((deviceAlarmConfig: IDeviceAlarmConfig) => {
                this.conditionAlarmConfigMap[deviceAlarmConfig.condition] = deviceAlarmConfig;
                this.conditionAlarmConfigCopyMap[deviceAlarmConfig.condition] = Common.Utils.clone(deviceAlarmConfig) as IDeviceAlarmConfig;
            });
            this.conditionKeys = Object.keys(this.conditionAlarmConfigMap);
            this.conditionKeys.sort().reverse();
            this.selectedCondition = "operation";
            console.log(`Selected condition ${this.selectedCondition}. Current copy ${this.getCurrentDeviceAlarmConfigCopy()}`);
        }

        private getCurrentDeviceAlarmConfig(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigMap[this.selectedCondition];
        }

        private getCurrentDeviceAlarmConfigCopy(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigCopyMap[this.selectedCondition];
        }

        private setMailAlert(alarmConfig: Models.IAlarmConfig, index: number): void {
            if (this.device !== undefined) {
                if (!alarmConfig.masked && !alarmConfig.levels[index].masked &&
                    ((alarmConfig.type as string) === 'relay' ||
                        (Common.Utils.exists(alarmConfig.levels[index].value) && alarmConfig.levels[index].value !== ''))) {

                    alarmConfig.levels[index].emailAlert = !alarmConfig.levels[index].emailAlert;
                }
            }

        }
    }
}

